import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
@Component({
	selector: 'auction-legend',
	imports: [
		NgClass,
		TranslateModule
	],
	templateUrl: './auction-legend.component.html',
	styleUrl: './auction-legend.component.scss',
})
export class AuctionLegendComponent {
	@Input() vertical: boolean = false;
}